// asyncronous, gaan we gebruiken om naar de api te gaan

import {
  api,
} from '@/utils';

import GARAGE_ACTION_TYPES from './garage.action-types';
import GARAGE_MUTATION_TYPES from './garage.mutation-types';

const GARAGE_ACTIONS = {
  [GARAGE_ACTION_TYPES.FETCH_DATA_GARAGES]({
    commit,
  }) {
    return new Promise((resolve, reject) => {
      api.get('garage/getall')
        .then((response) => {
          if (response.data != null) {
            commit(GARAGE_MUTATION_TYPES.APPEND_GARAGES, response.data);
            commit(GARAGE_MUTATION_TYPES.APPEND_GARAGE_SEARCH_RESULTS, response.data);
          }

          resolve();
        })
        .catch((error) => {
          commit(GARAGE_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [GARAGE_ACTION_TYPES.SEARCH_GARAGES]({
    commit,
  }, searchGaragesRequestModel) {
    return new Promise((resolve, reject) => {
      api.post('/searchgarage/getgaragesbycityandleaseid', searchGaragesRequestModel)
        .then(response => {
          if (response.data != null) {
            commit(GARAGE_MUTATION_TYPES.APPEND_GARAGE_SEARCH_RESULTS, response.data);
          }

          resolve();
        })
        .catch(error => {
          commit(GARAGE_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [GARAGE_ACTION_TYPES.FETCH_DATA_TIRECODES]({
    commit,
  }) {
    return new Promise((resolve, reject) => {
      api.get('searchtires/gettirecodes')
        .then((response) => {
          if (response.data != null) {
            commit(GARAGE_MUTATION_TYPES.APPEND_TIRECODES, response.data);
          }

          resolve();
        })
        .catch((error) => {
          commit(GARAGE_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [GARAGE_ACTION_TYPES.FETCH_MAINTENANCE_GARAGES]({
    commit,
  }, maintenanceDepotsIds) {
    return new Promise((resolve, reject) => {
      api.post('/searchgarage/getgaragesbymaintenanceids', maintenanceDepotsIds)
      .then(response => {
        if (response.data != null) {
          commit(GARAGE_MUTATION_TYPES.APPEND_GARAGE_SEARCH_RESULTS, response.data);
        }

        resolve();
      })
      .catch(error => {
        commit(GARAGE_MUTATION_TYPES.SET_ERROR, error);
        reject(error);
      });
    });
  },
};

export default GARAGE_ACTIONS;
